import {
  getFixBevoegdGezag,
  getFixBevoegdGezagId,
  getFixLineageBevoegdGezag,
  getFixLineageBevoegdGezagId,
} from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';
import { createInfiniteQuery } from '@/utils/tanstack-query/createQuery/createInifiniteQuery';

export const useBevoegdGezag = createQuery({
  key: ['bevoegdGezag'],
  queryFn: getFixBevoegdGezag,
});

export const useBevoegdGezagInfinite = createInfiniteQuery({
  key: ['bevoegdGezag', 'infinite'],
  queryFn: getFixBevoegdGezag,
});

export const useBevoegdGezagId = createQuery({
  key: ['bevoegdGezagId'],
  queryFn: getFixBevoegdGezagId,
});

export const useLineageBevoegdGezag = createQuery({
  key: ['lineageBevoegdGezag'],
  queryFn: getFixLineageBevoegdGezag,
});

export const useLineageBevoegdGezagId = createQuery({
  key: ['lineageBevoegdGezagId'],
  queryFn: getFixLineageBevoegdGezagId,
});
